import React from 'react'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import { ListItemIcon, ListSubheader, Grid, Tooltip, IconButton } from '@mui/material'
import EditInputData from "./EditInputData";
import DeleteInputData from './DeleteInputData'
import InputDataIcon from '@mui/icons-material/DataObject'
import { InputData } from '../../interfaces/input_data'
import CreateInputData from './CreateInputData'
import schema from '../../schemas/input_data.json'
import { JSONSchema7 } from 'json-schema'
import DownloadIcon from '@mui/icons-material/SaveAlt'
import axios from 'axios'
import { useParams } from 'react-router-dom'

export interface Props {
  disabled: boolean
  type: string
  data: InputData[]
  setData: React.Dispatch<React.SetStateAction<any[]>>
}

export default function InputDataList({ disabled, type, data, setData }: Props) {
  const { name } = useParams()
  return (
    <List
      dense
      subheader={
        <ListSubheader>
          <Grid container alignItems={'center'}>
            {type === 'generator_input_data' ? 'Generator Input Data' : 'Simulation Input Data'}
            <CreateInputData disabled={disabled} data={data} schema={schema as JSONSchema7} setData={setData} />
          </Grid>
        </ListSubheader>
      }
    >
      {data.map((obj: InputData, index: number) => {
        return (
          <ListItem
            key={index}
            secondaryAction={
              <>
                <EditInputData disabled={disabled} schema={schema as JSONSchema7} value={obj} setData={setData} />
                <Tooltip title='Download'>
                  <span>
                    <IconButton
                      disabled={disabled}
                      size='small'
                      onClick={async () => {
                        try {
                          const res = await axios.get(`${process.env.REACT_APP_API}/${name}/input_data/${obj.name}`, {
                            withCredentials: true,
                            responseType: 'blob',
                          })
                          const url = window.URL.createObjectURL(new Blob([res.data]))
                          const link = document.createElement('a')
                          link.href = url
                          link.setAttribute('download', obj.name + '.' + res.data.type.split('/')[1])
                          document.body.appendChild(link)
                          link.click()
                        } catch (err) {
                          console.log('err:', err)
                        }
                      }}
                    >
                      <DownloadIcon />
                    </IconButton>
                  </span>
                </Tooltip>
                <DeleteInputData disabled={disabled} type={type} value={obj} setData={setData} />
              </>
            }
            disablePadding
          >
            <ListItemButton disabled={disabled}>
              <ListItemIcon>
                <InputDataIcon />
              </ListItemIcon>
              <ListItemText
                primary={`${obj.name}`}
                secondary={`frequency: ${obj.data_frequency} s`}
                sx={{ '.MuiListItemText-secondary': { display: { xs: 'none', sm: 'block' } } }}
              />
            </ListItemButton>
          </ListItem>
        )
      })}
    </List>
  )
}
